/**
 * @generated SignedSource<<13e81eab8630bdbf88b94043d3ea0dd8>>
 * @relayHash 21de3735338c40328d20b9879f24e3ca
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b021f1f86af7a4bfe24b2c60c47d4b5fe6741a24c4f6e8a315eaad94dc95cfae

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraProjectStyle = "COMPANY_MANAGED_PROJECT" | "TEAM_MANAGED_PROJECT" | "%future added value";
export type src_jiraSoftwareListQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type src_jiraSoftwareListQuery$data = {
  readonly jira: {
    readonly isSubtasksEnabled: boolean | null | undefined;
    readonly jiraProjectByKey: {
      readonly createIssues: {
        readonly canPerform: boolean;
      };
      readonly projectStyle: JiraProjectStyle;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectContextProvider">;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"src_businessList_List_queryFragment">;
};
export type src_jiraSoftwareListQuery = {
  response: src_jiraSoftwareListQuery$data;
  variables: src_jiraSoftwareListQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider": withNewRankField_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider: {
    readonly get: () => boolean;
  };
});

import withNewRankField_provider from '@atlassian/jira-relay-provider/src/fun-1500-swap-business-inline-create-rank-fetcher.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v3 = [
  (v2/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "projectStyle"
},
v5 = [
  {
    "kind": "Literal",
    "name": "type",
    "value": "CREATE_ISSUES"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "canPerform"
},
v7 = [
  (v2/*: any*/)
],
v8 = {
  "args": (v7/*: any*/),
  "kind": "ScalarField",
  "name": "isSubtasksEnabled"
},
v9 = [
  (v6/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "fieldId"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "src_jiraSoftwareListQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "kind": "RequiredField",
                "field": (v4/*: any*/),
                "action": "THROW",
                "path": "jira.jiraProjectByKey.projectStyle"
              },
              {
                "kind": "RequiredField",
                "field": {
                  "alias": "createIssues",
                  "args": (v5/*: any*/),
                  "concreteType": "JiraProjectAction",
                  "kind": "LinkedField",
                  "name": "action",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": (v6/*: any*/),
                      "action": "THROW",
                      "path": "jira.jiraProjectByKey.createIssues.canPerform"
                    }
                  ],
                  "storageKey": "action(type:\"CREATE_ISSUES\")"
                },
                "action": "THROW",
                "path": "jira.jiraProjectByKey.createIssues"
              },
              {
                "kind": "FragmentSpread",
                "name": "ProjectContextProvider"
              }
            ]
          },
          (v8/*: any*/)
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "src_businessList_List_queryFragment"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "src_jiraSoftwareListQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              {
                "alias": "createIssues",
                "args": (v5/*: any*/),
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"CREATE_ISSUES\")"
              },
              (v10/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "projectId"
              },
              {
                "concreteType": "JiraAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "large"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "projectType"
              },
              {
                "kind": "ScalarField",
                "name": "status"
              },
              {
                "kind": "ScalarField",
                "name": "isFavourite"
              },
              {
                "alias": "assignIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "ASSIGN_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"ASSIGN_ISSUES\")"
              },
              {
                "alias": "administerProject",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_PROJECT_CONFIG"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
              },
              {
                "alias": "deleteIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "DELETE_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"DELETE_ISSUES\")"
              },
              {
                "alias": "editIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "EDIT_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"EDIT_ISSUES\")"
              },
              {
                "alias": "linkIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "LINK_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"LINK_ISSUES\")"
              },
              {
                "alias": "scheduleIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "SCHEDULE_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
              },
              {
                "alias": "transitionIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "TRANSITION_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"TRANSITION_ISSUES\")"
              },
              {
                "alias": "viewIssues",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "VIEW_ISSUES"
                  }
                ],
                "concreteType": "JiraProjectAction",
                "kind": "LinkedField",
                "name": "action",
                "plural": false,
                "selections": (v9/*: any*/),
                "storageKey": "action(type:\"VIEW_ISSUES\")"
              }
            ]
          },
          (v8/*: any*/),
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v7/*: any*/),
                "concreteType": "JiraJqlFieldWithAliases",
                "kind": "LinkedField",
                "name": "rankField",
                "plural": false,
                "selections": [
                  (v11/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "alias": "rankFieldOld",
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Literal",
                        "name": "aliasFieldIds",
                        "value": [
                          "rank"
                        ]
                      },
                      (v2/*: any*/)
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  }
                ],
                "concreteType": "JiraFieldConfigConnection",
                "kind": "LinkedField",
                "name": "jiraFieldConfigs",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraFieldConfigEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraIssueFieldConfig",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v11/*: any*/),
                          (v10/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b021f1f86af7a4bfe24b2c60c47d4b5fe6741a24c4f6e8a315eaad94dc95cfae",
    "metadata": {},
    "name": "src_jiraSoftwareListQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcfun1500swapbusinessinlinecreaterankfetcherrelayprovider": withNewRankField_provider
    }
  }
};
})();

(node as any).hash = "61bb861782021b761a02b9ba76dbad90";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
